import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function Mobilemenu() {
  return (

    <nav class="navbar-mobile">
      <ul class="navbar-nav">
                <li class="nav-item">
                  <Link className='nav-link' to='/home'>Home</Link>
                </li>
      
                <li class="nav-item">
                  <Link className='nav-link' to='/about'>About</Link>
                </li>
      
                <li class="nav-item dropdown dropdown-hover ">
                  <a data-mdb-dropdown-init class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
                    Courses
                  </a>
                  <div class="dropdown-menu mt-0" aria-labelledby="navbarDropdown" >
                    <ul>
                      <li><Link className='order-history-link' to='/skill-education'>Skill Education</Link></li>
                      <li><Link className='order-history-link' to='/traditional-education'>Traditional Education</Link></li>
                    </ul>
                  </div>
                </li>
      
                <li class="nav-item">
                  <Link className='nav-link' to='/admission'>Admission</Link>
                </li>
      
                <li class="nav-item">
                  <Link className='nav-link' to='/e-learning'>E-Learning</Link>
                </li>
      
                <li class="nav-item">
                  <Link className='nav-link' to='/recognition'>Recognition</Link>
                </li>
      
                 <li class="nav-item">
                  <Link className='nav-link' to='/result'>Results</Link>
                </li>
      
      
      
                <li class="nav-item">
                  <Link className='nav-link' to='/authorized-centers'>Authorized Centers</Link>
                </li>
      
                <li class="nav-item">
                  <Link className='nav-link' to='/contact'>Contact</Link>
                </li>
      
              </ul>

      <ul className='login'>


      </ul>




    </nav>
  )

}

export default Mobilemenu;
